import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {connect, useDispatch} from 'react-redux';
import { Row, Col, Input } from 'reactstrap';

import Axios from 'axios';
import shortid from 'shortid';

import {
    ReservaAPI,
    ConsultaAPI,
    VinculosAPI,
    SolicitacaoEmprestimoAPI,
    AcervoAPI,
} from '../../../../shared/http-requests';
import { upper, Permissao,APIHelper } from '../../../../shared/helpers';
import {INDICE_BUSCA_POR_COD_ACERVO} from "../../../../shared/config/config";
import { clearSubmenuSelected } from "../../../../store/ducks/dadosAcervo";
import Detalhes from "../../components/DadosAcervo/Detalhes";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import AcervoFechado from "../acervo/AcervoFechado";
import DadosProtocoloArmazem from "../acervo/DadosProtocoloArmazem";

const SecaoComentarios = React.lazy(() =>
    import('../../components/DadosAcervo/SecaoComentarios'),
);
const BaseTemplate = React.lazy(() => import('../template/BaseTemplate'));
const DadosAcervoCapa = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoCapa'),
);
const DadosAcervoMarc = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoMarc'),
);
const DadosAcervoHeader = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoHeader'),
);
const DadosAcervoReferencia = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoReferencia'),
);
const DadosAcervoPrincipal = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoPrincipal'),
);
const DadosAcervoExemplares = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoExemplares'),
);
const DadosAcervoDublinCore = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoDublinCore'),
);
const DadosAcervoReserva = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoReserva'),
);
const LinksDadosAcervo = React.lazy(() =>
    import('../../components/DadosAcervo/LinksDadosAcervo'),
);
const DadosAcervoSolicitacaoEmprestimo = React.lazy(() =>
    import('../../components/DadosAcervo/DadosAcervoSolicitacaoEmprestimo'),
);

const Kardex = React.lazy( () => import("../acervo/Kardex"));

const Sumarios = React.lazy( () => import("../acervo/Sumarios"));

const DadosEstatisticos = React.lazy( () => import("../acervo/DadosEstatisticos"));


const OutrasEdicoes = React.lazy(() =>
    import('../../components/OutrasEdicoes'),
);

const COD_ATIVIDADE_REFERENCIA = '33';
const COD_ATIVIDADE_MARC = '36';
const COD_ATIVIDADE_EXEMPLARES = '30';
const COD_ATIVIDADE_DUBLIN_CORE = '115';
const COD_ATIVIDADE_RESERVA = '18';
const COD_ATIVIDADE_SOLICITACAO_EMPRESTIMO = '75';
const COD_ATIVIDADE_COLECAO_KARDEX = '32';
const COD_ATIVIDADE_SUMARIOS = 'summary';
const COD_ATIVIDADE_SUMARIO_LIVRO = 'sumario_livro';
const COD_ATIVIDADE_DADOS_ESTATISTICOS = '74';
const SUB_MENU_DETALHES = 'detalhes';
export const SUB_MENU_MENSAGEM_ACERVO_FECHADO = 'mensagem_acervo_fechado'
const COD_ATIVIDADE_ACERVO_FECHADO = 'acervo_fechado';

const enderecosLinks = {
    '-1': 'capas',
    0: '',
    30: 'exemplares',
    33: 'referencia',
    36: 'marc',
    32: "colecao-kardex",
    'summary': "sumarios",
    18: 'reserva',
    31: 'localizacao',
    75: 'solicitacao-emprestimo',
    115: 'dublin-core',
    'sumario_livro': 'sumarios-livros',
    74: 'dados-estatisticos',
    'acervo_fechado': 'acervo-fechado'
};

const DadosAcervo = props => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    //? Codigo do acervo vindo pela rota:
    const codAcervo = props.match.params.codAcervo;
    //? Link disponíveis na div esquerda da página:
    const [links, setLinks] = useState(false);
    //? Link atual selecionado pelo usuário:
    const [linkAtual, mudarLinkAtual] = useState(null);
    //? Array com os códigos das permissoes
    const [permissoes, setPermissoes] = useState([33, 36, 115, 74]);
    //? Dados do acervo (principal)
    const [dadosAcervo, setDadosAcervo] = useState(false);
    //? Coleção de imagens das capas vindas do banco:
    const [imagesCarousel, insertImagesCarousel] = useState(false);
    //? Referência vinda do banco:
    const [referenciaAcervo, insertReferenciaAcervo] = useState(false);
    //? MARC vindo do banco:
    const [marcAcervo, insertMarcAcervo] = useState(false);
    //? Exemplares
    const [exemplares, setExemplares] = useState(false);
    //? Exemplares biblioteca
    const [exemplaresBiblioteca, setExemplaresBiblioteca] = useState(false);
    //? Localização
    const [localizacao, setLocalizacao] = useState(false);
    //? Dublin core
    const [dublinCore, setDublinCore] = useState(false);

    const [acervoLinks, setAcervoLinks] = useState([]);

    const [acervoAtual, setAcervoAtual] = useState(null);

    const {imagemPadrao} = props;

    //Quando mudar o cod acervo da URL, reseta os dados da tela
    useEffect(() => {
        mudarLinkAtual(null);

        if (permissoes.some(p => ![33, 36, 115].includes(p)))
            setPermissoes([33, 36, 115]);

        setDadosAcervo(false);
        insertMarcAcervo(false);
        insertReferenciaAcervo(false);
        insertImagesCarousel(false);
        setDublinCore(false);
        setExemplares(false);
        setLocalizacao(false);
        setExemplaresBiblioteca(false);
        setAcervoLinks([]);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [codAcervo]);

    // Carrega os links do menu esquerdo
    useEffect(() => {
        if (props.atividadesRx.length) {
            let collection = [
                ...props.atividadesRx
                    .filter(atividade =>
                        permissoes.includes(parseInt(atividade.cod_atividade)),
                    )
                    .map(atividade => {
                        let tempDesc = atividade.descricao
                            .split('-')
                            .pop()
                            .trim();

                        if (
                            atividade.cod_atividade === '30' &&
                            exemplaresBiblioteca &&
                            exemplaresBiblioteca.length > 0
                        ) tempDesc = 'Bibliotecas';

                        if(atividade.cod_atividade === '32')
                            tempDesc = t('ColecaoKardex')

                        if(atividade.cod_atividade === '74')
                            tempDesc = t('DadosEstatisticos')

                        return {
                            cod_atividade: atividade.cod_atividade,
                            link: enderecosLinks[atividade.cod_atividade] || '',
                            descricao: tempDesc,
                        };
                    }),
                { cod_atividade: '0', descricao: t('DadosAcervo'), link: '' },
                { cod_atividade: '-1', descricao: t('Capas') },
            ];

            collection = collection.sort((a, b) =>
                parseInt(a.cod_atividade) < parseInt(b.cod_atividade)
                    ? -1
                    : 1,
            )

            /**
             * Verificando permissão
             * Adicionando item de menu 'Sumários' após o item 'Coleção Kardex'
             */
            if(permissoes.includes(COD_ATIVIDADE_SUMARIOS)){
                collection.push({cod_atividade: 'summary',
                    descricao: t('Sumarios'),
                    link: enderecosLinks[COD_ATIVIDADE_SUMARIOS]});
            }

            if(permissoes.includes(COD_ATIVIDADE_SUMARIO_LIVRO)){
                collection.push({cod_atividade: 'sumario_livro',
                    descricao: t('SumariosOuDocumentosOnline'),
                    link: enderecosLinks[COD_ATIVIDADE_SUMARIO_LIVRO]});
            }

            /**
             * Só leva em consideração a permissão 74, sem verificar nas atividades
             */
            const hasAddedDadosEstatisticos = collection.some(l => l.cod_atividade == COD_ATIVIDADE_DADOS_ESTATISTICOS);
            if(!hasAddedDadosEstatisticos && permissoes.includes(parseInt(COD_ATIVIDADE_DADOS_ESTATISTICOS))) {
                collection.push({ cod_atividade: '74', descricao: t('DadosEstatisticos'), link: '' })
            }

            if(permissoes.includes(COD_ATIVIDADE_ACERVO_FECHADO)){
                collection.push({cod_atividade: 'acervo_fechado',
                    descricao: props.instituicaoRx.desc_armazem || t('AcervoFechado'),
                    link: enderecosLinks[COD_ATIVIDADE_ACERVO_FECHADO]});
            }


            setLinks(collection);
        }
    }, [props.atividadesRx, permissoes, exemplaresBiblioteca, t]);

    // Inicializa página com o link atual com base na propriedade passada pelo router.
    useEffect(() => {
        if (!linkAtual && links) {
            let codAtividade = props.linkCurrent || '0';
            mudarLinkAtual(
                links.filter(link => link.cod_atividade === codAtividade)[0],
            );
        }
    }, [linkAtual, links, props.linkCurrent]);

    // Caso o usuário tenha vindo pela url, efetua uma pesquisa automática para efeitos de estatística:
    useEffect(() => {
        if(acervoAtual !== null)
            return;


        if(props.consultaRx && props.statusRx){
            const {data} = props.consultaRx;
            if(data?.length > 0){
                const currentCollection = data.find(x => x.cod_acervo === codAcervo);
                if(currentCollection){
                    setAcervoAtual(currentCollection);
                    return;
                }
            }
        }

        ConsultaAPI.consulta({
            termo_pesquisa: codAcervo,
            coluna_um: 'INDICE_30',
            search_id: shortid.generate(),
            search_tab: getGuiaPesquisa(),
        })
            .then((response) => {
                const {data} = response;

                if(data)
                    setAcervoAtual(data[0])
            })
            .catch(error => {
                APIHelper.tratarErro(error)
                console.log(error)
            });

        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.consultaRx, props.statusRx]);
    
    // Buscar dados do acervo (principal)
    useEffect(() => {
        let cancelToken = Axios.CancelToken.source();
        if (props.statusRx && !dadosAcervo) {
            AcervoAPI.buscarDadosAcervo(codAcervo, cancelToken.token)
                .then(response => {
                    setDadosAcervo(response.data);
                })
                .catch(error => {
                    if (!Axios.isCancel(error))
                        setDadosAcervo({
                            error: true,
                            message: error.response.data.message,
                        });
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
    }, [codAcervo, props.statusRx, dadosAcervo]);

    // Pegar a coleção das imagens, caso ainda não tenha feito:
    useEffect(() => {
        let cancelToken = Axios.CancelToken.source();
        if (props.statusRx) {
            VinculosAPI.buscarImagensAcervo(codAcervo, 0, cancelToken.token)
                .then(response => insertImagesCarousel(response.data))
                .catch(error => {
                    if (!Axios.isCancel(error))
                        insertImagesCarousel({
                            error: true,
                            message: error.response.data.message,
                        });
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
    }, [codAcervo, props.statusRx]);

    // Pegar a coleção das imagens, caso ainda não tenha feito:
    useEffect(() => {
        let cancelToken = Axios.CancelToken.source();
        if (props.statusRx) {
            AcervoAPI.buscarLinks(codAcervo, cancelToken.token)
                .then(response => setAcervoLinks(response.data))
                .catch(error => {
                    if (!Axios.isCancel(error)) console.error(error);
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
    }, [codAcervo, props.statusRx]);

    // Buscar referência do acervo
    useEffect(() => {
        let cancelToken = Axios.CancelToken.source();
        if (
            props.atividadesRx.length &&
            (Permissao.tem(parseInt(COD_ATIVIDADE_REFERENCIA)) ||
                permissoes.some(p => p === 18) ||
                permissoes.some(p => p === 75)) &&
            props.statusRx &&
            !referenciaAcervo
        ) {
            AcervoAPI.buscarReferenciaAcervo(codAcervo, cancelToken.token)
                .then(response => insertReferenciaAcervo(response.data))
                .catch(error => {
                    if (!Axios.isCancel(error))
                        insertReferenciaAcervo({
                            error: true,
                            message: error.response.data.message,
                        });
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [codAcervo, props.statusRx, props.atividadesRx, permissoes]);

    // Buscar MARC
    useEffect(() => {
        let cancelToken = Axios.CancelToken.source();
        if (
            props.atividadesRx.length &&
            Permissao.tem(parseInt(COD_ATIVIDADE_MARC)) &&
            props.statusRx
        ) {
            AcervoAPI.buscarMarcAcervo(codAcervo, false, cancelToken.token)
                .then(response => insertMarcAcervo(response.data))
                .catch(error => {
                    if (!Axios.isCancel(error))
                        insertMarcAcervo({
                            error: true,
                            message: error.response.data.message,
                        });
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
    }, [codAcervo, props.statusRx, props.atividadesRx]);

    // Busca Exemplares
    useEffect(() => {
        let cancelToken = Axios.CancelToken.source();
        if (
            props.atividadesRx.length &&
            Permissao.tem(parseInt(COD_ATIVIDADE_EXEMPLARES)) &&
            props.statusRx
        ) {
            AcervoAPI.buscaExemplares(codAcervo, 0, cancelToken.token)
                .then(response => {
                    setExemplaresBiblioteca(response.data.bibliotecas);
                    setExemplares(response.data.campi);
                    setLocalizacao(response.data.localizacao);

                    //Se trouxe dados adiciona a permissão para exibir o link no menu
                    if (
                        Object.values(response.data.campi).length ||
                        response.data.bibliotecas.length
                    )
                        setPermissoes(p => [...p, 30]);
                })
                .catch(error => {
                    if (!Axios.isCancel(error)) return;
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
    }, [codAcervo, props.statusRx, props.atividadesRx]);

    //Busca os dados do dublin core
    useEffect(() => {
        let cancelToken = Axios.CancelToken.source();
        if (
            props.atividadesRx.length &&
            Permissao.tem(parseInt(COD_ATIVIDADE_DUBLIN_CORE)) &&
            props.statusRx
        ) {
            AcervoAPI.buscarDublinCoreAcervo(codAcervo, cancelToken.token)
                .then(response => setDublinCore(response.data))
                .catch(error => {
                    if (!Axios.isCancel(error))
                        setDublinCore({
                            error: true,
                            message: error.response.data.message,
                        });
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
    }, [codAcervo, props.statusRx, props.atividadesRx]);

    /**
     * Busca as permissões todas de uma vez
     */
    useEffect( () => {
        let cancelToken = Axios.CancelToken.source();
            AcervoAPI.buscarPermissoesMenuDadosAcervo(codAcervo, cancelToken.token)
                .then(response => {
                    if (response.data) {
                        setPermissoes(p => [...p, ...response.data])
                    };
                })
                .catch(error => {
                    if (!Axios.isCancel(error)) console.error(error);
                });
    }, [])

    useEffect(() => {
        dispatch(clearSubmenuSelected())
    }, [linkAtual]);

    const getContent = () => {
        if (linkAtual) {
            const { subMenuSelected } = props;

            switch (linkAtual.cod_atividade) {
                case '0':

                    if(subMenuSelected.parent == linkAtual.cod_atividade){
                        switch (subMenuSelected.submenu){
                            case SUB_MENU_DETALHES:
                                return <Detalhes />
                        }
                    }

                    return (
                        <DadosAcervoPrincipal
                            dados={dadosAcervo}
                            codAcervo={codAcervo}
                        />
                    );
                case '-1':
                    return <DadosAcervoCapa images={imagesCarousel} />;
                case COD_ATIVIDADE_REFERENCIA:
                    return (
                        <DadosAcervoReferencia referencia={referenciaAcervo} />
                    );
                case COD_ATIVIDADE_MARC:
                    return <DadosAcervoMarc marc={marcAcervo} />;
                case COD_ATIVIDADE_EXEMPLARES:
                    return (
                        <DadosAcervoExemplares
                            acervo={dadosAcervo}
                            exemplares={exemplares}
                            exemplaresBiblioteca={exemplaresBiblioteca}
                            localizacao={localizacao}
                            {...props}
                        />
                    );
                case COD_ATIVIDADE_DUBLIN_CORE:
                    return <DadosAcervoDublinCore dublinCore={dublinCore} />;
                case COD_ATIVIDADE_RESERVA:
                    return (
                        <DadosAcervoReserva
                            codAcervo={codAcervo}
                            referencia={referenciaAcervo[0]}
                        />
                    );
                case COD_ATIVIDADE_SOLICITACAO_EMPRESTIMO:
                    return (
                        <DadosAcervoSolicitacaoEmprestimo
                            codAcervo={codAcervo}
                            referencia={referenciaAcervo[0]}
                        />
                    );
                case COD_ATIVIDADE_COLECAO_KARDEX:
                    return (
                        <Kardex acervo={acervoAtual}/>
                    )
                case COD_ATIVIDADE_SUMARIOS:
                case COD_ATIVIDADE_SUMARIO_LIVRO:
                    return (
                        <Sumarios acervo={acervoAtual} tipo={linkAtual.cod_atividade} />
                    )
                case COD_ATIVIDADE_DADOS_ESTATISTICOS:
                    return (
                        <DadosEstatisticos acervo={acervoAtual} />
                    )
                case COD_ATIVIDADE_ACERVO_FECHADO:

                    if(subMenuSelected.parent == linkAtual.cod_atividade){
                        switch (subMenuSelected.submenu){
                            case SUB_MENU_MENSAGEM_ACERVO_FECHADO:
                                return <DadosProtocoloArmazem />
                        }
                    }

                    return(
                        <AcervoFechado acervo={acervoAtual} />
                    )
                default:
                    return false;
            }
        }
    };

    const getGuiaPesquisa = () => {
        if (props.ultimoLogRx) return props.ultimoLogRx.pesquisa;
        else if (props.guiasPesquisaRx.length)
            return props.guiasPesquisaRx.find(guia => guia.ordem === 0).codigo;
        else return '';
    };

    const handleSelectDadosAcervo = e => {
        mudarLinkAtual(links.find(l => l.cod_atividade === e.target.value));
        props.history.push(
            `/acervo/${codAcervo}/${enderecosLinks[e.target.value]}`,
        );
    };

    return (
        <BaseTemplate guiaSelecionada={getGuiaPesquisa()} extras={false}>
            <div className="consultaContent col-md-12 pad5">
                <Row className="bkbranco pad5 rad5 b-w2 b-tema10 b-solid">
                    <Col md="12" xs="12">
                        <DadosAcervoHeader
                            className="b-dotted-bottom"
                            consulta={props.consultaRx.data}
                            codAcervo={codAcervo}
                            ultimoLogRx={props.ultimoLogRx}
                            location={props.location}
                        />
                    </Col>
                    <Col md="12" xs="12">
                        <Row className="pt-3 pb-3 w-100">
                            <Col xs="12" md="3">
                                <LinksDadosAcervo
                                    codAcervo={codAcervo}
                                    links={links}
                                    linkAtual={linkAtual}
                                    mudarLinkAtual={mudarLinkAtual}
                                    exemplares={exemplares}
                                    exemplaresBiblioteca={exemplaresBiblioteca}
                                    capas={imagesCarousel}
                                    imagemPadrao={imagemPadrao}
                                    acervoAtual={acervoAtual}
                                />
                            </Col>
                            <Col
                                xs="12"
                                md="9"
                                className="pr-0 pl-0 border-left b-w1 b-tema50 mt-md-0 mt-3"
                            >
                                {linkAtual && (
                                    <Row className="b-solid-bottom b-w2 b-tema50 animated fadeIn">
                                        <Col md="8" xs="12" className="p-2">
                                            <h5 className="cortxt l20 align-center">

                                                {dadosAcervo &&
                                                !dadosAcervo.error
                                                    ? upper(
                                                          t(
                                                              linkAtual.descricao,
                                                          ),
                                                      ) +
                                                      ` - ${dadosAcervo.tipo_obra}`
                                                    : upper(
                                                          linkAtual.descricao,
                                                      )}
                                                {
                                                    props.subMenuSelected.submenu !== null && (
                                                        <>
                                                            <FontAwesomeIcon
                                                                icon="chevron-right"
                                                                className="s-13 mr-3 ml-3 cortxt corAlto1"
                                                            />
                                                            <span >{props.subMenuSelected.name}</span>
                                                        </>
                                                    )
                                                }
                                            </h5>
                                        </Col>
                                        {['0', '36', '115'].includes(
                                            linkAtual.cod_atividade,
                                        ) && [-1, null].includes(props?.subMenuSelected?.submenu) && (
                                            <Col
                                                md="4"
                                                xs="12"
                                                className="pb-2 pl-4 pr-4"
                                            >
                                                <Input
                                                    type="select"
                                                    className="b-tema20 preto70 s14"
                                                    value={
                                                        linkAtual.cod_atividade
                                                    }
                                                    onChange={e =>
                                                        handleSelectDadosAcervo(
                                                            e,
                                                        )
                                                    }
                                                >
                                                    <option value="0">{`${t(
                                                        'Exibicao',
                                                    )} -  ${t(
                                                        'Padrao',
                                                    )}`}</option>
                                                    {Permissao.tem(36) && (
                                                        <option value="36">{`${t(
                                                            'Exibicao',
                                                        )} - MARC`}</option>
                                                    )}
                                                    {Permissao.tem(115) && (
                                                        <option value="115">{`${t(
                                                            'Exibicao',
                                                        )} - Dublin Core`}</option>
                                                    )}
                                                </Input>
                                            </Col>
                                        )}
                                    </Row>
                                )}
                                <div>{getContent()}</div>
                                <div className='text-right'>
                                    <span className='s12 preto60 mt-2 mr-3'>{t('Acervo')} {codAcervo}</span>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={12}>
                        <OutrasEdicoes links={acervoLinks} />
                    </Col>
                    <Col md="12" xs="12">
                        <DadosAcervoHeader
                            className="b-dotted-top"
                            consulta={props.consultaRx.data}
                            codAcervo={codAcervo}
                            ultimoLogRx={props.ultimoLogRx}
                            location={props.location}
                        />
                    </Col>
                    {Permissao.tem(85) && (
                        <SecaoComentarios
                            codAcervo={codAcervo}
                            dadosAcervo={dadosAcervo}
                        />
                    )}
                </Row>
            </div>
        </BaseTemplate>
    );
};

const mapStateToProps = state => ({
    ultimoLogRx: state.pesquisa.log[state.pesquisa.log.length - 1],
    consultaRx: state.pesquisa.consulta,
    atividadesRx: state.pageConfig.atividades,
    statusRx: state.pageConfig.status,
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
    autoridades: state.dadosAcervo.autoridades,
    subMenuSelected: state.dadosAcervo.subMenuSelected,
    imagemPadrao: state.pesquisa.imagemPadrao,
    instituicaoRx: state.instituicao.data,
});

export default connect(mapStateToProps)(DadosAcervo);
